import WorkerInterval from './workerInterval';

const workerInterval = new WorkerInterval();
export const clearWorkerInterval = (id: string): void =>
    workerInterval.clearInterval(id);
export const setWorkerInterval = (
    callback: () => void,
    delay: number
): string | null => {
    return workerInterval.setInterval(callback, delay);
};
